import { AttributeBooleanMandatoryComponent } from './attribute/boolean-mandatory/boolean-mandatory.component';
import { AttributeImageComponent } from './attribute/image/image.component';
import { DocumentComponent } from './document.component';
import { DocumentDialogComponent } from './document-dialog/document-dialog.component';
import { AreaComponent } from './area/area.component';
import { AttributeComponent } from './attribute/attribute.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentItemComponent } from './document-item/document-item.component';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatInput, MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule, CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule, CommonUIModule, ImagePreviewModule } from '@sdbn/common';


@NgModule({
  declarations: [
    DocumentComponent,
    DocumentDialogComponent,
    AreaComponent,
    AttributeComponent,
    AttributeImageComponent,
    AttributeBooleanMandatoryComponent,
    DocumentItemComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonTranslationModule,
    CommonUIElementsModule,
    ApplicationClientCommonModule,
    CommonUIModule,
    CommonLayoutModule,
    ImagePreviewModule,
    MatCheckboxModule,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule
  ],
  exports: [
    DocumentComponent,
    DocumentDialogComponent
  ]
})
export class DocumentModule { }
